import script from "./ReportHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportHistory.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/reportList.css?vue&type=style&index=0&id=0397dec9&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0397dec9"]])

export default __exports__